"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _styles = require("@material-ui/core/styles");
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));
var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));
var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _MainButton = _interopRequireDefault(require("../../../../../Shared/Components/MainButton"));
var _List = _interopRequireDefault(require("@material-ui/core/List"));
var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));
var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));
var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));
var _i18n = require("../../../../../Framework/i18n");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      borderTop: "7px solid ".concat(theme.palette.primary.main)
    },
    titleRoot: {
      margin: 0,
      padding: theme.spacing(2)
    },
    title: {
      marginRight: 40
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    },
    contentRoot: {
      padding: theme.spacing(2)
    },
    actionsRoot: {
      margin: 0,
      padding: theme.spacing(1)
    }
  };
}, {
  name: 'InvalidConfigurationNotice'
});
var InvalidConfigurationNotice = function InvalidConfigurationNotice(_ref) {
  var validationErrors = _ref.validationErrors,
    show = _ref.show,
    close = _ref.close,
    open = _ref.open,
    adminMode = _ref.adminMode;
  var theme = (0, _styles.useTheme)();
  var fullScreen = (0, _useMediaQuery["default"])(theme.breakpoints.down('sm'));
  var classes = useStyles();
  var initialRender = (0, _react.useRef)(true);
  (0, _react.useEffect)(function () {
    if (adminMode || !initialRender.current) {
      validationErrors.length && open();
    } else {
      initialRender.current = false;
    }
  }, [open, validationErrors, adminMode, initialRender]);
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    fullScreen: fullScreen,
    open: show,
    classes: {
      paper: classes.root
    }
  }, /*#__PURE__*/_react["default"].createElement(_DialogTitle["default"], {
    disableTypography: true,
    className: classes.titleRoot
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: 'h5',
    className: classes.title
  }, (0, _i18n.T)('invalidConfigurationNotice.title')), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    "aria-label": "close",
    className: classes.closeButton,
    onClick: close
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null))), /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], {
    className: classes.contentRoot
  }, /*#__PURE__*/_react["default"].createElement(_List["default"], null, validationErrors.map(function (_ref2, index) {
    var title = _ref2.title,
      errors = _ref2.errors;
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
      key: index
    }, index !== 0 && /*#__PURE__*/_react["default"].createElement(_Divider["default"], null), /*#__PURE__*/_react["default"].createElement(_ListItem["default"], null, /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
      primary: /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        component: 'span',
        variant: 'h6'
      }, title),
      secondary: /*#__PURE__*/_react["default"].createElement(_List["default"], null, errors.map(function (error, index) {
        return /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
          component: 'span',
          key: index
        }, (0, _i18n.T)("invalidConfigurationNotice.errorTypes.".concat(error.message), _objectSpread({}, error.amounts && {
          minimumAmount: error.amounts.minAmount,
          selectedAmount: error.amounts.selectedAmount
        })));
      })),
      secondaryTypographyProps: {
        component: 'span'
      }
    })));
  }))), /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], null, /*#__PURE__*/_react["default"].createElement(_MainButton["default"], {
    onClick: close,
    variant: "contained"
  }, "OK")));
};
var _default = exports["default"] = InvalidConfigurationNotice;